// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  width: 100%;
  padding: 0;
}

.app-header {
  width: 100%;
  background: rgba(0, 0, 0, 0.1);
  padding: 20px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  gap: 20px;
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  overflow: hidden;
}

/* Fancy AstroProfile Title */
.app-title {
  background: linear-gradient(135deg, #ffffff 0%, #e0e7ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-family: 'Orbitron', 'Playfair Display', 'Georgia', serif;
  font-size: 32px;
  margin: 0;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-style: italic;
  text-shadow: 0 0 30px rgba(102, 126, 234, 0.4);
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.3));
  animation: glow 3s ease-in-out infinite;
  grid-column: 2;
  text-align: center;
  white-space: nowrap;
}

@keyframes glow {
  0%, 100% {
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.3));
    text-shadow: 0 0 20px rgba(102, 126, 234, 0.3);
  }
  50% {
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.6));
    text-shadow: 0 0 40px rgba(102, 126, 234, 0.6);
  }
}

.home-placeholder {
  grid-column: 1;
  width: 88px;
  flex-shrink: 0;
  visibility: hidden;
}

.home-btn {
  background: white;
  color: #667eea;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  flex-shrink: 0;
  grid-column: 1;
}

.home-btn:hover {
  background: #f0f0f0;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.home-btn:active {
  transform: translateY(0);
}

/* Header Navigation Buttons Container */
.header-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
  grid-column: 3;
  justify-self: end;
  flex-wrap: wrap;
  justify-content: flex-end;
  min-width: 0;
}

/* Navigation button in header */
.nav-header-btn {
  background: white;
  color: #667eea;
  border: none;
  padding: 9px 16px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  flex-shrink: 0;
}

.nav-header-btn:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.nav-header-btn:active {
  transform: translateY(0);
}

.view-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 40px 20px;
  gap: 20px;
}

.form-view {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 40px 20px;
  width: 100%;
}

.chart-view {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 40px 20px;
  width: 100%;
}

/* Ensure chart container is centered */
.chart-view > div {
  width: 100%;
  display: flex;
  justify-content: center;
}

.content-wrapper {
  display: grid;
  grid-template-columns: 400px 1fr;
  gap: 30px;
  align-items: flex-start;
  width: 100%;
  max-width: 1400px;
  margin-top: 20px;
}

.left-panel {
  display: flex;
  justify-content: center;
  overflow: visible;
}

.right-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.welcome-message {
  background: white;
  padding: 50px 40px;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.welcome-message h2 {
  color: #333;
  font-size: 28px;
  margin-bottom: 15px;
}

.welcome-message p {
  color: #666;
  font-size: 16px;
  margin-bottom: 30px;
  line-height: 1.6;
}

.info-box {
  background: #f5f5f5;
  padding: 20px;
  border-left: 4px solid #667eea;
  border-radius: 5px;
  text-align: left;
}

.info-box h3 {
  color: #333;
  font-size: 16px;
  margin-bottom: 10px;
}

.info-box p {
  color: #555;
  font-size: 14px;
  margin: 0;
  line-height: 1.6;
}

/* Responsive design */
@media (max-width: 1024px) {
  .app-title {
    font-size: 24px;
  }

  .home-btn {
    padding: 10px 20px;
    font-size: 14px;
  }

  .content-wrapper {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .left-panel {
    order: 2;
  }

  .right-panel {
    order: 1;
  }
}

@media (max-width: 768px) {
  .app-header {
    padding: 12px;
  }

  .header-content {
    gap: 12px;
    padding: 0 10px;
  }

  .app-title {
    font-size: 20px;
    letter-spacing: 1px;
    grid-column: 2;
  }

  .home-btn {
    padding: 8px 12px;
    font-size: 12px;
    grid-column: 1;
  }

  .header-buttons {
    gap: 6px;
  }

  .nav-header-btn {
    padding: 7px 12px;
    font-size: 11px;
  }

  .logout-btn {
    padding: 7px 12px;
    font-size: 11px;
  }

  .view-container {
    padding: 20px 15px;
  }

  .content-wrapper {
    gap: 15px;
  }

  .welcome-message {
    padding: 30px 20px;
  }

  .welcome-message h2 {
    font-size: 22px;
  }

  .welcome-message p {
    font-size: 14px;
  }

  .info-box p {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .app-header {
    padding: 10px;
  }

  .header-content {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 0 8px;
    justify-content: space-between;
    align-items: center;
  }

  .app-title {
    font-size: 18px;
    letter-spacing: 0.8px;
    order: 1;
    flex-basis: 100%;
    text-align: center;
    margin: 0;
  }

  .home-btn {
    padding: 6px 10px;
    font-size: 11px;
    order: 2;
  }

  .logout-btn {
    padding: 6px 10px;
    font-size: 11px;
    order: 3;
  }

  .header-buttons {
    order: 4;
    flex-basis: 100%;
    gap: 4px;
    justify-content: center;
  }

  .nav-header-btn {
    padding: 6px 10px;
    font-size: 10px;
  }

  .view-container {
    padding: 15px 10px;
  }

  .welcome-message {
    padding: 20px 15px;
  }

  .welcome-message h2 {
    font-size: 20px;
  }
}

/* Logout Button Styling */
.logout-btn {
  padding: 9px 16px;
  background: linear-gradient(135deg, #ef5350 0%, #e53935 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  flex-shrink: 0;
}

.logout-btn.in-header {
  grid-column: 3;
  justify-self: end;
}

.logout-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(239, 83, 80, 0.4);
}

.logout-btn:active {
  transform: translateY(0);
}

/* Login Button Styling */
.login-btn {
  padding: 9px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.login-btn:active {
  transform: translateY(0);
}

/* Login Modal Overlay */
.login-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  overflow-y: auto;
  padding: 20px;
}

/* Login Modal Content */
.login-modal-content {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  padding: 30px 28px;
  max-width: 500px;
  width: 100%;
  position: relative;
  animation: slideIn 0.3s ease-out;
  max-height: 90vh;
  overflow-y: auto;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Modal Close Button */
.modal-close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: all 0.3s ease;
  z-index: 10;
}

.modal-close-btn:hover {
  background: #f0f0f0;
  color: #333;
  transform: rotate(90deg);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,6DAA6D;EAC7D,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,sDAAsD;EACtD,uCAAuC;EACvC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,sDAAsD;IACtD,8CAA8C;EAChD;EACA;IACE,sDAAsD;IACtD,8CAA8C;EAChD;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,cAAc;IACd,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,wBAAwB;AAC1B","sourcesContent":[".app-container {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 100vh;\n  width: 100%;\n  padding: 0;\n}\n\n.app-header {\n  width: 100%;\n  background: rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n}\n\n.header-content {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  max-width: 1400px;\n  width: 100%;\n  margin: 0 auto;\n  gap: 20px;\n  position: relative;\n  padding: 0 20px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n/* Fancy AstroProfile Title */\n.app-title {\n  background: linear-gradient(135deg, #ffffff 0%, #e0e7ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-family: 'Orbitron', 'Playfair Display', 'Georgia', serif;\n  font-size: 32px;\n  margin: 0;\n  font-weight: 800;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  font-style: italic;\n  text-shadow: 0 0 30px rgba(102, 126, 234, 0.4);\n  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.3));\n  animation: glow 3s ease-in-out infinite;\n  grid-column: 2;\n  text-align: center;\n  white-space: nowrap;\n}\n\n@keyframes glow {\n  0%, 100% {\n    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.3));\n    text-shadow: 0 0 20px rgba(102, 126, 234, 0.3);\n  }\n  50% {\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.6));\n    text-shadow: 0 0 40px rgba(102, 126, 234, 0.6);\n  }\n}\n\n.home-placeholder {\n  grid-column: 1;\n  width: 88px;\n  flex-shrink: 0;\n  visibility: hidden;\n}\n\n.home-btn {\n  background: white;\n  color: #667eea;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  white-space: nowrap;\n  flex-shrink: 0;\n  grid-column: 1;\n}\n\n.home-btn:hover {\n  background: #f0f0f0;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n.home-btn:active {\n  transform: translateY(0);\n}\n\n/* Header Navigation Buttons Container */\n.header-buttons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  grid-column: 3;\n  justify-self: end;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  min-width: 0;\n}\n\n/* Navigation button in header */\n.nav-header-btn {\n  background: white;\n  color: #667eea;\n  border: none;\n  padding: 9px 16px;\n  border-radius: 5px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.nav-header-btn:hover {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n.nav-header-btn:active {\n  transform: translateY(0);\n}\n\n.view-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  padding: 40px 20px;\n  gap: 20px;\n}\n\n.form-view {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 40px 20px;\n  width: 100%;\n}\n\n.chart-view {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 40px 20px;\n  width: 100%;\n}\n\n/* Ensure chart container is centered */\n.chart-view > div {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.content-wrapper {\n  display: grid;\n  grid-template-columns: 400px 1fr;\n  gap: 30px;\n  align-items: flex-start;\n  width: 100%;\n  max-width: 1400px;\n  margin-top: 20px;\n}\n\n.left-panel {\n  display: flex;\n  justify-content: center;\n  overflow: visible;\n}\n\n.right-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.welcome-message {\n  background: white;\n  padding: 50px 40px;\n  border-radius: 10px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  max-width: 500px;\n  width: 100%;\n}\n\n.welcome-message h2 {\n  color: #333;\n  font-size: 28px;\n  margin-bottom: 15px;\n}\n\n.welcome-message p {\n  color: #666;\n  font-size: 16px;\n  margin-bottom: 30px;\n  line-height: 1.6;\n}\n\n.info-box {\n  background: #f5f5f5;\n  padding: 20px;\n  border-left: 4px solid #667eea;\n  border-radius: 5px;\n  text-align: left;\n}\n\n.info-box h3 {\n  color: #333;\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n\n.info-box p {\n  color: #555;\n  font-size: 14px;\n  margin: 0;\n  line-height: 1.6;\n}\n\n/* Responsive design */\n@media (max-width: 1024px) {\n  .app-title {\n    font-size: 24px;\n  }\n\n  .home-btn {\n    padding: 10px 20px;\n    font-size: 14px;\n  }\n\n  .content-wrapper {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .left-panel {\n    order: 2;\n  }\n\n  .right-panel {\n    order: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .app-header {\n    padding: 12px;\n  }\n\n  .header-content {\n    gap: 12px;\n    padding: 0 10px;\n  }\n\n  .app-title {\n    font-size: 20px;\n    letter-spacing: 1px;\n    grid-column: 2;\n  }\n\n  .home-btn {\n    padding: 8px 12px;\n    font-size: 12px;\n    grid-column: 1;\n  }\n\n  .header-buttons {\n    gap: 6px;\n  }\n\n  .nav-header-btn {\n    padding: 7px 12px;\n    font-size: 11px;\n  }\n\n  .logout-btn {\n    padding: 7px 12px;\n    font-size: 11px;\n  }\n\n  .view-container {\n    padding: 20px 15px;\n  }\n\n  .content-wrapper {\n    gap: 15px;\n  }\n\n  .welcome-message {\n    padding: 30px 20px;\n  }\n\n  .welcome-message h2 {\n    font-size: 22px;\n  }\n\n  .welcome-message p {\n    font-size: 14px;\n  }\n\n  .info-box p {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .app-header {\n    padding: 10px;\n  }\n\n  .header-content {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 0 8px;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .app-title {\n    font-size: 18px;\n    letter-spacing: 0.8px;\n    order: 1;\n    flex-basis: 100%;\n    text-align: center;\n    margin: 0;\n  }\n\n  .home-btn {\n    padding: 6px 10px;\n    font-size: 11px;\n    order: 2;\n  }\n\n  .logout-btn {\n    padding: 6px 10px;\n    font-size: 11px;\n    order: 3;\n  }\n\n  .header-buttons {\n    order: 4;\n    flex-basis: 100%;\n    gap: 4px;\n    justify-content: center;\n  }\n\n  .nav-header-btn {\n    padding: 6px 10px;\n    font-size: 10px;\n  }\n\n  .view-container {\n    padding: 15px 10px;\n  }\n\n  .welcome-message {\n    padding: 20px 15px;\n  }\n\n  .welcome-message h2 {\n    font-size: 20px;\n  }\n}\n\n/* Logout Button Styling */\n.logout-btn {\n  padding: 9px 16px;\n  background: linear-gradient(135deg, #ef5350 0%, #e53935 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.logout-btn.in-header {\n  grid-column: 3;\n  justify-self: end;\n}\n\n.logout-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(239, 83, 80, 0.4);\n}\n\n.logout-btn:active {\n  transform: translateY(0);\n}\n\n/* Login Button Styling */\n.login-btn {\n  padding: 9px 16px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n  flex-shrink: 0;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.login-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n}\n\n.login-btn:active {\n  transform: translateY(0);\n}\n\n/* Login Modal Overlay */\n.login-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(5px);\n  overflow-y: auto;\n  padding: 20px;\n}\n\n/* Login Modal Content */\n.login-modal-content {\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  padding: 30px 28px;\n  max-width: 500px;\n  width: 100%;\n  position: relative;\n  animation: slideIn 0.3s ease-out;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Modal Close Button */\n.modal-close-btn {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: #999;\n  cursor: pointer;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  z-index: 10;\n}\n\n.modal-close-btn:hover {\n  background: #f0f0f0;\n  color: #333;\n  transform: rotate(90deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
